import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
  height: 100%;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.xm};
`

export const CardMaterialInsertContent = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  justify-content: space-between;
`

export const TitleCardMaterialInsert = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};

  #MaterialsInsertTitle {
    font-size: ${theme.typography.sizes.sm};
    font-weight: ${theme.typography.weight.xl};
    color: ${theme.colors.neutral.black};
  }

  #MaterialsInsertSubtitle {
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.xl};
    color: ${theme.colors.neutral.light};
  }
`
